import { Controller, TextInput, useFormContext, useTranslations } from "@jti/ui";

import type { FormFieldConfig } from "@checkout-v2/formFields/types/FormFieldConfig.types";

type TextInputFieldProps = {
  fieldConfig: FormFieldConfig;
  className?: string;
  dataTestId?: string;
};

export const TextInputField = ({ fieldConfig, className, dataTestId }: TextInputFieldProps) => {
  const form = useFormContext();
  const { __ } = useTranslations();

  return (
    <Controller
      name={fieldConfig.name}
      control={form.control}
      render={({ field, fieldState }) => (
        <TextInput
          {...field}
          label={fieldConfig.label}
          placeholder={fieldConfig.placeholder}
          type="text"
          disabled={fieldConfig.registerOptions?.disabled}
          isError={!!fieldState?.error}
          errorText={fieldState?.error?.message}
          required={!!fieldConfig.registerOptions?.required}
          containerClassName={className}
          data-testid={dataTestId as string}
        />
      )}
      rules={{ required: __("form_validation.field_required") }}
    />
  );
};
